import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import Hr from "@saleor/components/Hr";
import RadioGroupField from "@saleor/components/RadioGroupField";
import { translateSaleRangeTypes } from "@saleor/discounts/translations";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import { FormChange } from "@saleor/hooks/useForm";
import { SaleType } from "@saleor/types/globalTypes";
import { getFormErrors } from "@saleor/utils/errors";
import getDiscountErrorMessage from "@saleor/utils/errors/discounts";
import React from "react";
import { useIntl } from "react-intl";

import { SaleDetailsPageFormData } from "../SaleDetailsPage";
const useStyles = makeStyles(
  theme => ({
    hr: {
      margin: theme.spacing(2, 0)
    }
  }),
  {
    name: "SaleValue"
  }
);
export interface SaleValueProps {
  currencySymbol: string;
  data: SaleDetailsPageFormData;
  disabled: boolean;
  errors: DiscountErrorFragment[];
  onChange: FormChange;
}
export enum SaleRangeType {
  SPECIFIC_PRODUCT = "SPECIFIC_PRODUCT",
  EXCLUDE_PRODUCT = "EXCLUDE_PRODUCT"
}
const SaleValue: React.FC<SaleValueProps> = ({
  currencySymbol,
  data,
  disabled,
  errors,
  onChange
}) => {
  const intl = useIntl();
  const classes = useStyles();
  const translatedSaleTypes = translateSaleRangeTypes(intl);

  const saleTypeChoices = Object.values(SaleRangeType).map(type => ({
    label: translatedSaleTypes[type],
    value: type
  }));
  const formErrors = getFormErrors(["value"], errors);

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Value",
          description: "sale value, header"
        })}
      />
      <CardContent>
        <TextField
          disabled={disabled}
          fullWidth
          label={intl.formatMessage({
            defaultMessage: "Discount Value",
            description: "sale discount"
          })}
          error={!!formErrors.value}
          name="value"
          InputProps={{
            endAdornment:
              data.type === SaleType.FIXED || data.type === SaleType.DIRECT
                ? currencySymbol
                : "%"
          }}
          helperText={getDiscountErrorMessage(formErrors.value, intl)}
          value={data.value}
          onChange={onChange}
        />
        <Hr className={classes.hr} />
        <RadioGroupField
          choices={saleTypeChoices}
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Sale Specific Information"
          })}
          name={"rangeType" as keyof SaleDetailsPageFormData}
          value={data.rangeType}
          onChange={onChange}
        />
      </CardContent>
    </Card>
  );
};

SaleValue.displayName = "SaleValue";
export default SaleValue;
